import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux'
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import { useEffect } from 'react';
import { useState } from 'react';



const actions = [
  { icon: <FileCopyIcon />, name: 'Copy' },
  { icon: <SaveIcon />, name: 'Save' },
  { icon: <PrintIcon />, name: 'Print' },
  { icon: <ShareIcon />, name: 'Share' },
];

export default function SpeedDialTooltipOpen(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const gridtheme = useSelector(state => state.themeData.gridtheme)
  const [topMargin, setTopMargin] = useState(props?.actions?.length == 2 ? 128 : 182)


  console.log("props?.actions?.length", props?.actions?.length);


  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        height: '44px',
        width: '44px',
        overflow: 'visible',
        marginRight: '10px',
      }}
    >
      {/* <Backdrop open={open} onClick={handleClose} sx={{ zIndex: 1040 }} /> */}
      <SpeedDial
        ariaLabel={props?.label}
        sx={{
          // position: 'absolute',
          top: 0,
          left: 0,
          '& .MuiSpeedDial-fab': {
            backgroundColor: gridtheme?.gridHeader,
            ':hover': {
              backgroundColor: gridtheme?.gridHeader + 'AA',
            },
            height: '44px',
            width: '44px',
            minHeight: '44px',
            position: 'relative',
          },
          '& .MuiSpeedDial-actions': {
            paddingTop: '30px',
          },
          '& .MuiSpeedDialAction-fab': {
            width: '40px',
            height: '40px',
            minHeight: '40px',
          },
          '& .MuiSpeedDialAction-staticTooltipLabel': {
            whiteSpace: 'nowrap',
            fontFamily: 'Cairo',
            fontSize: '14px',
            padding: '6px 12px',
            borderRadius: '4px',
          },
        }}
        icon={props?.icon}
        direction="down"
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {props?.actions.map((action) => (
          <SpeedDialAction
            key={action?.key}
            icon={action?.icon}
            tooltipTitle={action?.name}
            tooltipOpen
            onClick={(e) => {
              action?.onClick?.(e);
              handleClose();
            }}
          />
        ))}
      </SpeedDial>
    </Box>
  );
}
